import React from 'react'
import { useState } from 'react'

export const SignUpLogIn = () => {

    const [action, setAction] = useState('Sign Up')

    const handleAction = (e) => {
        setAction(e.target.innerText)
    }

    

  return (
    <>
     <h1>{action}</h1> 
    
    <div className='form'> 
        {action ==='Sign Up' ? (
        <>
        <label htmlFor="name">Name:</label>
        <input type="text" id="name" name="name" required />
        </>
        ) 
        : 
        null}
        <label htmlFor="email">Email:</label>
        <input type="email" id="email" name="email" required />
        <label htmlFor="password">Password:</label>
        <input type="password" id="password" name="password" required />
        {action === 'Log In' ? (<><p>Lost password. <a href="#">Click Here</a></p></>) : null} 
        
    
            <div className='buttons'>
            <button className={action !== 'Sign Up' ? (`gray`) : null} onClick={handleAction}>Sign Up</button>
            <button className={action !== 'Log In' ? ('gray') : null} onClick={handleAction}>Log In</button>
            </div>
            
      </div>
      
      
    </>
  )
}
